import { useQuery } from '@tanstack/react-query';
import { auditClaim, type TxAuditResult } from '@/lib/businessVerify';

/**
 * Audit a verification claim's txid on-chain (did it pay ~the expected fee to
 * the verification address?). Used by the admin panel to show a payment
 * verdict next to each claim.
 */
export function useClaimAudit(txid: string | undefined, expectedSats: number) {
  const enabled = !!txid && /^[0-9a-f]{64}$/i.test(txid);

  return useQuery<TxAuditResult>({
    queryKey: ['claim-audit', txid ?? '', expectedSats],
    enabled,
    queryFn: ({ signal }) => auditClaim(txid!, expectedSats, signal),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
